import React from 'react';
// Supports weights 100-900
import "@fontsource/inter"; // Defaults to weight 400
import "@fontsource/inter/400.css"; // Specify weight
import "@fontsource/inter/400-italic.css"; // Specify weight and style
import { Provider } from 'react-redux';
import { store } from './state';
import AuthenticationStateHandler from './components/organisms/AuthenticationStateHandler';
import { createBrowserRouter, Route, RouterProvider, Routes } from 'react-router-dom';
import { AuthenticationProvider, Home, HomeCustomer, I18n, Loading, Login, OpenIdStoreCallbackUrlHandler, SimpleLayout } from './components';
import { configureAxiosDefaults } from './AxiosConfig';
import { PrimeReactProvider } from 'primereact/api';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './theme/themes/mytheme/theme.scss';
import './App.css';
import { WaardeOverdracht } from './components/pages/waardeoverdracht/WaardeOverdracht';


function App() {

    configureAxiosDefaults(store);

    const router = createBrowserRouter([
        {
            path: "*", element: <Root/>, handle: {
                crumb: () => "Home"
            }
        },
    ]);

    function Root() {
        return (
            <AuthenticationProvider>
                <AuthenticationStateHandler
                    loading={<Loading/>}
                    unAuthenticated={
                        <Routes>
                            <Route path="/" element={<SimpleLayout/>}>
                                <Route path="/" element={<Home/>}/>
                                <Route path="*" element={<Home/>}/>
                                <Route path="/mijn" element={<Login/>}/>
                            </Route>
                        </Routes>
                    }
                    authenticated={
                        <Routes>
                            <Route path="/" element={<SimpleLayout/>}>
                                <Route path="/" element={<Home/>}/>
                                <Route path="*" element={<Home/>}/>
                            </Route>
                            <Route path="/mijn" element={<SimpleLayout/>}>
                                <Route path="" element={<HomeCustomer/>}/>
                                <Route path="waardeoverdracht" element={<WaardeOverdracht/>}/>
                            </Route>
                        </Routes>
                    }
                />
            </AuthenticationProvider>
        );
    }


    return (
        <Provider store={store}>
            <I18n/>
            <PrimeReactProvider>
                <OpenIdStoreCallbackUrlHandler>
                    <RouterProvider router={router}/>
                </OpenIdStoreCallbackUrlHandler>
            </PrimeReactProvider>
        </Provider>
    );
}

export default App;
